import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// Remote device settings for point of sale devices
export default ProtoBaseModel.extend({
  deviceCredentialToken: attr(String),
  enabled: attr(Boolean)
});